export const formatErrorStatus = (error: any) => {
  return (
    error &&
    parseInt(error.split(' ').slice(0, 1).join(' '))
  );
};

export const formatErrorMessage = (error: any) => {
  console.log('error', error)
  return (
    error && typeof error === 'string' ?
    error.split(' ').slice(2).join(' ').replace(/"/g, '') : error
  );
};

